module.exports = __webpack_public_path__ + "img/profili_cover.6e8966a6.png";